<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">
      <el-form-item label="名称">
        <el-input type="textarea" v-model ="formData.text"></el-input>
      </el-form-item>

      <el-form-item label="货位">
        <el-select v-model="formData.sub" placeholder="请选择">
          <el-option
            v-for="(item,index) in options"
            :key="index"
          :label="item.filename"
            :value="item.fid"
            ></el-option>

        </el-select>
      </el-form-item>
      <el-form-item :label="$t('form_notes')">
        <el-input type="textarea" v-model="formData.desc"></el-input>
      </el-form-item>
     </el-form>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    subData: Object,
    nodeData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },
    subData: {
      handler(n, o) {

      },
      deep:true// 深度监听父组件传过来对象变化
    },
  },
  mounted() {
    const { properties, text } = this.$props.nodeData
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
    }

    if (text && text.value) {
      this.$data.formData.text = text.value
    }
    const{list}=this.$props.subData;
    if (list){this.options=list}

  },
  data() {
    return {
      formData: {
        name: '',
        extent:[],
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',

      },
      options:[],
    }
  },

}
</script>
<style scoped>
</style>
